// path: src/utils/progression.js

const LS_MAX_LEVEL_KEY = "mmu_max_level";

// Challenging = last 3x3 level => Level 5
export const CHALLENGING_START_LEVEL = 5;

// Insane = last 4x4 level => Level 10
export const INSANE_START_LEVEL = 10;

// These match App.js `levels[].threshold` exactly (Level 1..10)
const LEVEL_THRESHOLDS = [4, 8, 17, 26, 35, 51, 67, 83, 99, 115];

// Score you should have at the *start* of a level:
// Level 1 => 0
// Level 2 => 4
// Level 3 => 8
// ...
export function scoreAtStartOfLevel(levelNumber) {
    if (levelNumber <= 1) return 0;
    const prev = LEVEL_THRESHOLDS[levelNumber - 2];
    return Number.isFinite(prev) ? prev : 0;
}

export function getMaxUnlockedLevel() {
    const raw = window.localStorage.getItem(LS_MAX_LEVEL_KEY);
    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
}

export function setMaxUnlockedLevel(levelNumber) {
    const current = getMaxUnlockedLevel();
    const next = Math.max(current, levelNumber);
    window.localStorage.setItem(LS_MAX_LEVEL_KEY, String(next));
    return next;
}

export function isChallengingUnlocked() {
    return getMaxUnlockedLevel() >= CHALLENGING_START_LEVEL;
}

export function isInsaneUnlocked() {
    return getMaxUnlockedLevel() >= INSANE_START_LEVEL;
}
